module.exports = __webpack_public_path__ + "img/color-developer.f00baa43.svg";